import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdBannerTemplatesDuplicateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/banner_templates",
];
